export default __webpack_public_path__ + "static/media/sms.6d414e49.svg";